import ScooterInfoWindow from './ScooterInfoWindow';

export default ScooterInfoWindow;
